module.exports = __webpack_public_path__ + "static/media/condition-diagnosis-family-anamnesis-diary.28a91866.svg";